<template>
  <div class="itinerario-root" ref="itinerarioRef">
    <div class="portada-wrapper">
      <div class="torn-edge">
        <img src="@/assets/IMG_7694.webp" alt="Portada" class="img-fluid" ref="imgPortada" />
      </div>
    </div>

    <div class="itinerario-body">
      <h2 class="main-title" ref="titleRef">Itinerario</h2>

      <div class="events-container">
        <div 
          v-for="(item, index) in eventos" 
          :key="index" 
          class="event-card"
          ref="eventCards"
        >
          <div class="icon-wrapper">
            <img :src="item.icono" class="event-icon" />
          </div>

          <div class="content-wrapper">
            <h3 class="event-title">{{ item.titulo }}</h3>
            <p class="event-time">{{ item.hora }}</p>
          </div>

          <div v-if="index < eventos.length - 1" class="spacer-line"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'ItinerarioCentrado',
  setup() {
    const itinerarioRef = ref(null);
    const titleRef = ref(null);
    const imgPortada = ref(null);
    const eventCards = ref([]); // Ref para los elementos del v-for

    const eventos = [
                 { titulo: 'RECEPCIÓN', hora: '4:30 PM', icono: require('@/assets/recep.png') },

                 { titulo: 'CEREMONIA CIVIL', hora: '5:00 PM', icono: require('@/assets/ceremonia.png') },

      { titulo: 'NUESTRA UNIÓN ANTE DIOS', hora: '5:30 PM', icono: require('@/assets/ceremonia.png') },

      { titulo: 'CENA', hora: '6:30 PM', icono: require('@/assets/cen.png') },
      { titulo: 'FIESTA', hora: '8:00 PM - en adelante', icono: require('@/assets/fiest.png') }
    ];

    onMounted(() => {
      // 1. Animación de entrada inkjhkjhkjkjhkkjkjhkjkjkjkjhkjkjkjhkjjkjkjhjjhgjhjhgjhgjhicial (Imagen de portada)
      gsap.fromTo(imgPortada.value, 
        { opacity: 0, scale: 1.1 },
        { opacity: 1, scale: 1, duration: 1.8, ease: "power2.out" }
      );

      // 2. Timeline Maestra para el cuerpo del itinerario
      // Usamos un solo ScrollTrigger para toda la sección
      const mainTl = gsap.timeline({
        scrollTrigger: {
          trigger: itinerarioRef.value,
          start: "top 85%", // Se activa pronto para que se vea en móvil
          once: true
        }
      });

      // Animamos el título
      mainTl.fromTo(titleRef.value, 
        { y: 30, opacity: 0 },
        { y: 0, opacity: 1, duration: 1, ease: "power3.out" }
      );

      // Animamos las tarjetas en cascada (stagger)
      // Seleccionamos todos los iconos y contenidos para una entrada fluida
      eventCards.value.forEach((card) => {
        const icon = card.querySelector('.event-icon');
        const content = card.querySelector('.content-wrapper');
        const spacer = card.querySelector('.spacer-line');

        // Aparece el icono con un pequeño giro y escala
        mainTl.fromTo(icon, 
          { scale: 0, opacity: 0, rotate: -15 },
          { scale: 1, opacity: 1, rotate: 0, duration: 0.7, ease: "back.out(1.7)" },
          "-=0.5" // Solapa ligeramente con la animación anterior
        );

        // Aparece el texto
        mainTl.fromTo(content, 
          { x: -15, opacity: 0 },
          { x: 0, opacity: 1, duration: 0.6, ease: "power2.out" },
          "-=0.4"
        );

        // Se dibuja la línea divisoria
        if (spacer) {
          mainTl.fromTo(spacer, 
            { scaleY: 0, opacity: 0 },
            { scaleY: 1, opacity: 1, duration: 0.8, ease: "power1.inOut" },
            "-=0.3"
          );
        }
      });
    });

    return { eventos, itinerarioRef, titleRef, imgPortada, eventCards };
  }
}
</script>


<style scoped>
.itinerario-root {
  background-color: #fcfaf8;
  /* Textura de papel muy sutil */
  background-image: url("https://www.transparenttextures.com/patterns/cream-paper.png");
}

.portada-wrapper {
  width: 100%;
  height: 480px;
  overflow: hidden;
}

.torn-edge {
  width: 100%;
  height: 100%;
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 1000 1000' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0 H 1000 V 980 Q 950 978 900 980 T 800 979 T 700 982 T 600 978 T 500 981 T 400 979 T 300 982 T 200 978 T 100 981 T 0 979 Z' fill='black'/%3E%3C/svg%3E");
  mask-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 1000 1000' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0 H 1000 V 980 Q 950 978 900 980 T 800 979 T 700 982 T 600 978 T 500 981 T 400 979 T 300 982 T 200 978 T 100 981 T 0 979 Z' fill='black'/%3E%3C/svg%3E");
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;
}

.img-fluid { width: 100%; height: 100%; object-fit: cover; }

.itinerario-body {
  padding: 20px 20px;
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
}

.main-title {
 font-size: 30px !important;

  letter-spacing: 4px;

color: #1a1a1a;

  text-align: center;

  padding: 70px 20px;

  font-family: 'Playfair Display', serif;
  margin-bottom: 0;

  font-weight: 500;

  opacity: 0;
}

.events-container {
  display: flex;
  flex-direction: column;
  gap: 60px;
}

.event-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.icon-wrapper {
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.event-icon {
  width: 155px;
  height: 155px;
  object-fit: contain;

  /* CAFÉ ELEGANTE */
  filter:
    sepia(1)
    saturate(1.2)
    hue-rotate(-10deg)
    brightness(0.72)
    contrast(1);
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.event-title {
  font-family: 'Playfair Display', serif;
  font-size: 16px;
  letter-spacing: 3px;
  color: #333;
  margin: 0;
  font-weight: 400;
}

.event-time {
  font-family: 'Playfair Display', serif;
  font-size: 18px;
  font-weight: 600;
  color: #a68b6d; /* Dorado mate */
  margin: 0;
}

/* Línea separadora muy minimalista */
.spacer-line {
  margin-top: 10px;
  width: 30px;
  height: 1px;
  background-color: #e0d6cc;
}

@media (max-width: 600px) {
  .main-title { font-size: 3rem; }
  .event-title { font-size: 14px; }
}
</style>